<template>
  <div class="selectOrg">
    <div class="orgSelectBox">
      <div class="orgWildBox">
        <div
          :class="['orgLeftBox', { iswarn: isWarning }]"
          v-loading="loading || searching"
        >
          <div class="searchDiaBox">
            <el-input
              size="small"
              placeholder="输入关键字"
              prefix-icon="el-icon-search"
              v-model="searchOrgPer"
              @input="searchOrgPerFun"
            ></el-input>
            <div class="search-person-box">
              <el-select
                v-model="keyType"
                placeholder="搜索成员"
                size="mini"
                @change="handleSelectChange"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="orgsBox">
            <el-tabs v-model="tabActive" @tab-click="handleTabChange">
              <el-tab-pane label="组织架构" name="first" />
              <el-tab-pane label="业务条线" name="second" />
            </el-tabs>
          </div>

          <div class="org-data-content">
            <div class="org-title" v-show="isShow">
              <span @click="nextTree" :class="{ active: title }">新希望 </span>
              <span v-if="title"> / {{ title }}</span>
            </div>
            <div class="all" v-show="isShow && !isSect">
              <el-checkbox v-model="allChecked" @change="selectAll"
                >全选</el-checkbox
              >
            </div>
            <div class="tips" v-show="!isShow">
              搜索结果：包含“{{ searchOrgPer }}”的搜索结果
            </div>
            <div class="org-table-content">
              <div
                class="org-item"
                v-for="(item, index) in sourceOrgs"
                :key="index + '_' + item.departmentId"
              >
                <div class="check-box">
                  <el-checkbox
                    :disabled="item.type === 'SECTION'"
                    v-model="item.isCheck"
                    :class="{ 'is-section': isSect }"
                    @change="checkChange(index, 0)"
                  >
                    <div class="logo-box">
                      <span>{{ item.name }}</span>
                    </div>
                  </el-checkbox>
                </div>
                <div
                  :class="['next-level', { grey: item.isCheck }]"
                  @click="nextTree(item)"
                  v-show="item.type !== 'LINE'"
                >
                  <span>下级</span>
                </div>
              </div>
              <div
                class="user-item"
                v-for="(item, index) in userGroup"
                :key="item.userId"
              >
                <div class="check-box">
                  <el-checkbox
                    v-model="item.isCheck"
                    @change="checkChange(index, 1)"
                  >
                    <div class="logo-box">
                      <span
                        >{{ item.name
                        }}<span v-show="item.username"
                          >（{{ item.username }}）</span
                        ></span
                      >
                    </div>
                  </el-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="personPeople">
          <div class="selected-box">
            已选：<span>{{ userNum }}名用户，{{ orgsNum }}个部门</span>
          </div>
          <div class="personBox">
            <div
              class="personCard"
              v-for="item in selectedList"
              :key="item.sourceCode"
            >
              <div class="imgBox">
                <img :src="checkAvator(item)" slot="error" />
                <div class="desc-content">
                  <span class="desc-title"
                    >{{ item.name
                    }}<span v-show="item.username"
                      >（{{ item.username }}）</span
                    ></span
                  ><span class="depart" v-show="item.userId">{{
                    item.departmentName || '新希望'
                  }}</span>
                </div>
              </div>
              <div class="close" @click="deletePersonOrg(item)">
                <i class="el-icon-close"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryDepartment, queryUser } from '@/api/index';
import { debounce } from '@/common/js/mUtils';
import defaultUser from '@/common/images/head.png';
import defaultOrg from '@/common/images/org.svg';

export default {
  name: 'selectTab',
  props: {
    title: {
      type: String,
      default: ''
    },
    allChecked: {
      type: Boolean,
      default: false
    },
    isWarning: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: true
    },
    isLine: {
      type: Boolean,
      default: true
    },
    sourceOrgs: {
      type: Array,
      default: () => []
    },
    userGroup: {
      type: Array,
      default: () => []
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    isLine(val) {
      this.tabActive = !val ? 'first' : 'second';
    }
  },
  computed: {
    isSect() {
      const sArr =
        this.sourceOrgs.filter(item => item.type === 'SECTION') || [];
      return sArr.length > 0;
    },
    checkAvator() {
      return function(item) {
        if (item.userId) {
          return item.avatar || this.defaultUser;
        }
        return this.defaultOrg;
      };
    },
    orgsNum() {
      const departs = this.selectedList.filter(item =>
        Object.keys(item).includes('departmentId')
      );
      return departs.length;
    },
    userNum() {
      const users = this.selectedList.filter(item =>
        Object.keys(item).includes('userId')
      );
      return users.length;
    }
  },
  data() {
    return {
      defaultOrg,
      defaultUser,
      options: [
        {
          value: '0',
          label: '成员'
        },
        {
          value: '1',
          label: '部门'
        }
      ],
      searching: false,
      keyType: '0',
      tabActive: 'first',
      personList: [],
      searchOrgPer: ''
    };
  },
  methods: {
    nextTree(row) {
      if (!row.isCheck) {
        this.$emit('selectNextLevel', row);
      }
    },
    // 复选全部
    selectAll() {
      this.$emit('selectAllNode');
    },
    // 复选单节点
    checkChange(num, type = 0) {
      // type 0组织  1员工
      this.$emit('checkNode', {
        type,
        index: num
      });
    },
    // 切换组织类型
    handleTabChange({ name }) {
      if (name === 'first') {
        // 查询组织人员
        this.$emit('initSource');
      } else {
        // 查询条线
        this.$emit('searchLines');
      }
    },
    // 删除数据
    deletePersonOrg(item) {
      this.$emit('removeNode', {
        sourceCode: item.sourceCode,
        type: Object.keys(item).includes('userId') ? 'users' : 'sourceOrgs'
      });
    },
    // 防抖查询
    searchOrgPerFun() {
      const fn = this.querOrgPerson;
      debounce(fn(), 2000);
    },
    // 查询组织人员
    querOrgPerson() {
      if (this.searchOrgPer) {
        if (this.keyType === '0') {
          this.queryUser(this.searchOrgPer);
        } else {
          this.queryDepartment(this.searchOrgPer);
        }
      } else {
        this.$emit('initSource');
      }
    },
    // 切换类型
    handleSelectChange() {
      this.querOrgPerson();
    },
    // 判断是否含有字母
    hasLetter(str) {
      for (let i in str) {
        let asc = str.charCodeAt(i);
        if ((asc >= 65 && asc <= 90) || (asc >= 97 && asc <= 122)) {
          return true;
        }
      }
      return false;
    },
    // 查询用户
    async queryUser(name) {
      this.searching = true;
      try {
        // USERNAME
        const { body, code, message } = await queryUser({
          queryType: this.hasLetter(name) ? 'USERNAME' : 'NAME',
          param: name
        });
        if (code === '0000') {
          this.$emit('searchNode', {
            source: body,
            type: 0
          });
        } else {
          this.$message.error(message);
        }
      } catch (err) {
        this.$message.error('系统错误');
      }
      this.searching = false;
    },
    // 查询部门
    async queryDepartment(name) {
      this.searching = true;
      try {
        const { body, code, message } = await queryDepartment({
          departmentName: name
        });
        if (code === '0000') {
          this.$emit('searchNode', {
            source: body,
            type: 1
          });
        } else {
          this.$message.error(message);
        }
      } catch (err) {
        this.$message.error('系统错误');
      }
      this.searching = false;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .is-section {
    .el-checkbox__input {
      display: none;
    }
    .el-checkbox__label {
      position: relative;
      left: -20px;
    }
  }
  .is-disabled {
    .el-checkbox__label {
      color: #606266 !important;
      font-size: 14px;
      word-break: break-all;
    }
  }
}
.selectOrg {
  height: 568px;
  padding: 8px 20px;
  border-radius: 15px;
  padding-bottom: 20px;
  .el-tree-node > .el-tree-node__children {
    overflow: initial !important;
  }
  .searchDiaBox {
    position: relative;
    width: 100%;
    height: 28px;
    ::v-deep {
      .el-input > .el-input__inner {
        border-radius: 100px !important;
      }
    }
    .search-person-box {
      position: absolute;
      top: 0;
      right: 2px;
      width: 96px;
      z-index: 999;
      ::v-deep {
        .el-input__inner {
          margin-top: 2px;
          ::placeholder {
            color: #999;
            font-size: 18px;
          }
        }
      }
    }
  }
  .orgsBox {
    ::v-deep {
      .el-tabs__nav-wrap {
        display: flex;
        justify-content: center;
        margin-top: 10px;
      }
    }
  }
  .org-data-content {
    .org-title span {
      &:first-child {
        cursor: pointer;
      }
    }
    .active {
      color: #19B366;
    }
    .all {
      margin: 10px 0;
    }
    .tips {
      font-size: 12px;
      color: #8f959e;
      margin: 0 0 10px;
    }
    .org-table-content {
      .org-item,
      .user-item {
        display: flex;
        justify-content: space-between;
        margin: 15px 0;
        cursor: pointer;
        .check-box {
          display: flex;
          flex-direction: row;
          align-items: center;
          flex-wrap: nowrap;
          .logo-box {
            margin-left: 10px;
          }
        }
      }
      .grey {
        color: #bbbfc4;
        cursor: not-allowed;
      }
    }

    ::v-deep {
      .el-table__row {
        cursor: pointer;
        td:first-child {
          display: flex;
          justify-content: flex-start;
          padding-left: 0;
          .cell {
            padding-left: 0;
          }
        }
      }
    }
  }
  .orgSelectBox {
    width: 100%;
    height: calc(100% - 40px);
    margin-top: 12px;
    .orgWildBox {
      margin-top: 10px;
      height: calc(100% - 24px);
      border: 1px solid rgba(205, 207, 212, 1);
      display: flex;
      flex-direction: row;
      border-radius: 4px;
      .orgLeftBox {
        padding: 15px;
        height: 100%;
        width: 52%;
        border-right: 1px solid rgba(205, 207, 212, 1);
        overflow-y: auto;
        &.iswarn {
          border: 1px solid #ff4f4a;
        }
      }
      .personPeople {
        height: 100%;
        padding: 15px;
        width: 48%;
        overflow-y: auto;

        .personBox {
          width: 100%;
          .personCard {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-top: 20px;
            cursor: pointer;
            &:first-child {
              margin-top: 30px;
            }
            .imgBox {
              display: flex;
              flex-wrap: nowrap;
              align-items: center;
              img {
                width: 32px;
                height: 32px;
                object-fit: contain;
                border-radius: 16px;
              }
              .desc-content {
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                .desc-title {
                  font-size: 14px;
                  color: #18263c;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .depart {
                  font-size: 12px;
                  color: #7e838c;
                  margin-top: 5px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
